import React from 'react';
import { isAndroid, isIOS } from '../../utils/getUserAgent';
import fieldParams from '../../const/fieldParams';

const DownloadCurbAppWeb = () => {
  const { downloadUrlList } = fieldParams['downloadAppWeb'];

  if (!isAndroid() && !isIOS()) return <></>;

  return (
    <div className="download-curb-links">
      <div className="download-message">
        Request your next ride using <br />
        the Curb app!
      </div>
      <div className="download-buttons">
        {isAndroid() && (
          <a
            className="download-curb-btn download-curb-app-play-store"
            href={`${downloadUrlList.android}`}
            target="_blank"
          />
        )}
        {isIOS() && (
          <a
            className="download-curb-btn download-curb-app-apple-store"
            href={`${downloadUrlList.iphone}`}
            target="_blank"
          />
        )}
      </div>
    </div>
  );
};

export default DownloadCurbAppWeb;
